import QRious from 'qrious';
import { useEffect, useState } from 'react';
export var useQrious = function (options) {
    var qrious = useState(function () { return new QRious(options); })[0];
    var _a = useState(function () { return qrious.toDataURL(options.mime); }), dataUrl = _a[0], setDataUrl = _a[1];
    useEffect(function () {
        qrious.set(options);
        setDataUrl(qrious.toDataURL(options.mime));
    }, [options, qrious]);
    return [dataUrl, qrious];
};
//# sourceMappingURL=use-qrious.js.map